"use client";
import * as React from "react";
import { DataTable, type Column } from "../DataTable";
import { PageHeader, StatCard, Card2 } from "../ModuleHelpers";
import { useERP, formatBDT, formatNum } from "@/lib/erp/store";
import { BarChart3, TrendingUp } from "lucide-react";

export function BIDashboardModule() {
  const erp = useERP();
  const rows = erp.salesOrders.slice(0, 6).map(o => ({
    id: o.id, so: o.soNumber, customer: erp.getCustomer(o.customerId)?.name ?? "—",
    zone: erp.getCustomer(o.customerId)?.zone ?? "—",
    total: o.total, margin: o.margin, status: o.status,
  }));
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="BI Dashboard" desc="Cross-functional analytics with drill-down views." icon={BarChart3} />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Total Sales" value={formatBDT(erp.salesInvoices.reduce((s, i) => s + i.amount, 0))} tone="text-primary" icon={TrendingUp} />
        <StatCard label="Active SOs" value={formatNum(erp.salesOrders.length)} />
        <StatCard label="Open AR" value={formatBDT(erp.customers.reduce((s, c) => s + c.outstanding, 0))} tone="text-destructive" />
        <StatCard label="Stock Value" value={formatBDT(erp.products.reduce((s, p) => s + p.costPrice * erp.getStock(p.id), 0))} />
      </div>
      <Card2 title="Sales Order Snapshot">
        <DataTable
          columns={[
            { key: "so", header: "SO #", sortable: true, render: r => <span className="font-mono text-xs">{r.so}</span> },
            { key: "customer", header: "Customer" },
            { key: "zone", header: "Zone" },
            { key: "total", header: "Total", align: "right", sortable: true, render: r => formatBDT(r.total) },
            { key: "margin", header: "Margin %", align: "right", render: r => `${r.margin.toFixed(1)}%` },
          ] as Column<typeof rows[number]>[]}
          data={rows}
          rowKey={r => r.id}
          searchKeys={["so", "customer", "zone"]}
        />
      </Card2>
    </div>
  );
}
